import { compose } from 'ramda'
import { withHandlers, withState } from 'recompose'
import { withTheme } from 'modules/util'
import { connect } from 'react-redux'

import { resetState } from 'modules/app/actions'

import startOverTheme from './theme.scss'

const handleToggleStartOver = ({
  setShowConfirmStartOver,
  showConfirmStartOver
}) => () => {
  setShowConfirmStartOver(!showConfirmStartOver)
}

const handleStartOver = props => () => {
  props.resetState()
  window.location = '/'
}

export default compose(
  connect(null, { resetState }),
  withState('showConfirmStartOver', 'setShowConfirmStartOver', false),
  withHandlers({ handleToggleStartOver, handleStartOver }),
  withTheme(startOverTheme)
)



// WEBPACK FOOTER //
// ./client/modules/user/components/StartOver/enhancers.js